// extracted by mini-css-extract-plugin
module.exports = {"ResultWrapper":"ResultPage_ResultWrapper__qzfRL"};